<template>
  <div class="gd-searh__input-wrap">
    <div class="gd-searh__input-wrap-inner">
      <input
        ref="searchInput"
        type="text"
        class="gd-searh__input"
        placeholder="Search by address, suburb..."
      />
      <button v-if="loading" class="gd-searh__btn">
        <div class="loader"></div>
      </button>
      <p v-if="responseMessage" class="gd-searh__not-found">{{ responseMessage }}</p>
    </div>
    <div @click="setfilterOpen" class="gd-searh__btn gd-searh__btn--filter">
      <svg>
        <use xlink:href="#icon-sliders-h-regular"></use>
      </svg>
      <div class="gd-searh__num">{{ selectedCount }}</div>
    </div>
    <transition name="slide-up-fade" mode="out-in">
      <MobFilters v-if="filterOpen" @close="setfilterOpen" />
    </transition>
    <Filters /> 
    <div ref="info" class="d-none"></div>
  </div>
</template>
<script setup lang="ts">
import Filters from "./filter/Filters.vue";
import MobFilters from "./filter/MobFilters.vue";
import { useGetCategory } from "../../composables/getCategory";
import { onMounted, type Ref, ref } from "vue";
import { useProductStore } from "../../store/product";
import { storeToRefs } from "pinia";

const { searchAuto, searchInput, responseMessage, loading } = useGetCategory();
const { selectedCount } = storeToRefs(useProductStore());

onMounted(() => {
  searchAuto();
})

const filterOpen: Ref<boolean> = ref(false)

function setfilterOpen() {
      const mainWrap = document.getElementById("mainContent") as HTMLElement | undefined
      const searchWrap = document.getElementById("navSearch") as HTMLElement | undefined
      const mapBtn = document.getElementById("mapBtn") as HTMLElement | undefined
      if(!mainWrap || !searchWrap) return
      if (filterOpen.value) {
        filterOpen.value = false
        mainWrap.style.zIndex = '0'
        mainWrap.style.position = "static"
        searchWrap.style.zIndex = '1'
        document.documentElement.style.overflowY = "auto"
        document.body.style.overflowY = "auto"
        mapBtn?.classList.remove("d-none")
      } else {
        filterOpen.value = true
        mainWrap.style.position = "relative"
        mainWrap.style.zIndex = '99'
        searchWrap.style.zIndex = '99'
        document.documentElement.style.overflowY = "hidden"
        document.body.style.overflowY = "hidden"
        mapBtn?.classList.add("d-none")
      }
    }

</script>